import React from 'react';
import { RevealOnScroll } from '../ui/RevealOnScroll';
import { TextLink } from '../ui/TextLink';
export function Designer() {
  return <section id="designer" className="bg-taupe flex flex-col md:flex-row" data-id="element-96">
      {/* Left Column - Image */}
      <div className="w-full md:w-1/2 h-[60vh] md:h-auto relative" data-id="element-97">
        <img src="https://cdn.magicpatterns.com/uploads/f4hYupY7kGWRmBeAeUFw49/spaces-image1.jpg" alt="Anna Paty on a forest path" className="absolute inset-0 w-full h-full object-cover" data-id="element-98" />
      </div>

      {/* Right Column - Text */}
      <div className="w-full md:w-1/2 py-24 px-6 md:px-12 lg:px-[80px] flex items-center" data-id="element-99">
        <div className="max-w-[600px]" data-id="element-100">
          <RevealOnScroll data-id="element-101">
            <p className="font-mono text-[12px] tracking-[0.2em] uppercase text-parchment mb-6" data-id="element-102">
              CHAPTER FOUR. THE DESIGNER.
            </p>
            <h2 className="font-serif italic text-parchment text-3xl md:text-[48px] mb-12" data-id="element-103">
              A journey in form and feeling.
            </h2>

            <div className="font-mono text-parchment/90 text-[14px] leading-[1.9] space-y-6 mb-16" data-id="element-104">
              <p data-id="element-105">
                Anna Paty graduated Summa Cum Laude from Arizona State
                University, earning a Bachelor of Science in Interior
                Architecture alongside a Certificate in Creative Writing.
                Currently calling the Southwestern Desert home, she has served
                on the team of award-winning luxury design firms in both
                Scottsdale, Arizona and San Francisco, California.
              </p>
              <p data-id="element-106">
                Her devotion to storytelling has taken many forms. First the
                rhythm of music and dance. Then the tangible performance of
                theater and the unique art of the written word. Now, its
                expression has taken root in a true physical manifestation. The
                design of space itself.
              </p>
              <p data-id="element-107">
                Through the language of form, texture, light, and color, she
                translates the rich tapestry of her clients' stories and
                histories into evocative spaces that stir emotion and invite the
                poetry that is life to unfold.
              </p>
            </div>

            <div className="mb-12" data-id="element-108">
              <div className="font-serif italic text-brass text-[28px] mb-2" data-id="element-109">
                Anna Paty
              </div>
              <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-parchment/60" data-id="element-110">
                PRINCIPAL DESIGNER, EST. SCOTTSDALE
              </div>
            </div>

            <TextLink href="#contact" className="text-parchment" data-id="element-111">
              work with me &rarr;
            </TextLink>
          </RevealOnScroll>
        </div>
      </div>
    </section>;
}